/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { cardWidth, sidebarWidth, dashboardHorizontalPadding } from 'blb-styles/constants';
const cardMargin = 16;
export const cardGroupMaxWidth = cardWidth * 2 + cardMargin;
export const cardWrapperStyles = StyleSheet.create({
  cardGroup: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: cardGroupMaxWidth
  },
  singleCardWrapper: {
    flexBasis: cardWidth,
    flexShrink: 0,
    ':nth-child(odd)': {
      marginRight: cardMargin
    },
    ':nth-child(n + 3)': {
      marginTop: cardMargin
    },
    [`@media (max-width: ${cardGroupMaxWidth + dashboardHorizontalPadding * 2 + sidebarWidth}px)`]: {
      ':not(:first-child)': {
        marginTop: cardMargin
      }
    }
  }
});